import { graphql, HttpResponse } from 'msw'
import {
  type EnrollmentMultiDocumentVerificationData,
  type EnrollmentMultiDocumentVerificationSubmitOutput,
} from '../../../../models'
import { DocumentVerificationStatus } from '../../../../models/enrollment/enrollment'

export const getEnrollmentMultiDocumentVerificationDataMock: EnrollmentMultiDocumentVerificationData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/document-verification',
  enrollmentData: {
    applicationId: '123',
  },
}

export const submitEnrollmentMultiDocumentVerificationDataMock: EnrollmentMultiDocumentVerificationSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/next-page-here',
}

let callCount = 0

export const submitEnrollmentMultiSDocVerificationCheckStatusDataMock = () => {
  callCount++

  return {
    __typename: 'SubmitEnrollmentSuccess',
    path: '/enrollment/hycs/document-verification-complete',
    documentVerificationStatus:
      callCount >= 3 ? DocumentVerificationStatus.Complete : DocumentVerificationStatus.Pending,
    documentVerificationUrl: 'https://example.com',
  }
}

export const mockGetEnrollmentMultiDocumentVerificationData = graphql.mutation(
  'getEnrollmentMultiDocumentVerificationData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: getEnrollmentMultiDocumentVerificationDataMock } })
  },
)

export const mockSubmitEnrollmentMultiDocumentVerificationData = graphql.mutation(
  'submitEnrollmentMultiDocumentVerificationData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentMultiDocumentVerificationDataMock } })
  },
)

export const mockSubmitEnrollmentMultiDocVerificationCheckStatusData = graphql.mutation(
  'submitEnrollmentMultiDocVerificationCheckStatusData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentMultiSDocVerificationCheckStatusDataMock() } })
  },
)

export const mockEnrollmentMultiDocumentVerification = [
  mockGetEnrollmentMultiDocumentVerificationData,
  mockSubmitEnrollmentMultiDocumentVerificationData,
  mockSubmitEnrollmentMultiDocVerificationCheckStatusData,
]
